<div class="project-name-sec p-3">
  <div class="header text-right">
    <button class="btn btn-sm btn-radius rounded-pill" (click)="addNewProFn()" [disabled]="isSaveLoader">
      <lucide-icon name="plus"></lucide-icon> Add New Project
    </button>
  </div>
  <div class="main_part">
    <div class="usernames">
      <div class="username" *ngFor="let item of projectTrackerList">
        <!-- <span>{{ item.screenName }}</span> -->
        <input type="text" value="{{ item.screenName }}" [(ngModel)]="item.screenName" />
      </div>
    </div>
    <div class="table_main mt-3">
      <table class="table">
        <thead>
          <tr>
            <th *ngFor="let item of columnList; let i = index" style="min-width: 120px;">
              <span class="d-flex align-items-center gap-1">
                <input type="text" [value]="item.colName" [(ngModel)]="item.colName" />
                <span (click)="changeType(item, i)">({{ item.type }})</span>
                <button class="btn btn-sm btn-radius rounded-pill" *ngIf="item.type == 'dropdown'"
                  (click)="dropdownPopup(item, i)">
                  Option
                </button>
              </span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of projectTrackerList; let i = index">
            <td *ngFor="let obj of item.isAllow; let in = index">
              <lucide-icon [strokeWidth]="3" size="22" [name]="obj ? 'check' : 'x'"
                [color]="obj ? '#48b02c' : '#ed1b2e'" (click)="projectAvaliable(item.id, in)"></lucide-icon>
            </td>
            <td style="width: 120px;">
              <!-- <button class="btn bg-g-lightGreen btn-sm">
                delete
              </button> -->
              <span class="cursor-pointer fg-red" (click)="deleteProjecTracker(item.id)"><span
                  class="fa fa-trash"></span> Delete
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card_footer py-2 text-right">
    <button class="btn btn-sm btn-radius rounded-pill" (click)="saveNewProjectTrackerFn()" [disabled]="isSaveLoader">
      <lucide-icon size="16" class="mr-1" name="save-all"></lucide-icon>Save
      <i *ngIf="isSaveLoader" class="fa fa-circle-o-notch fa-spin" style="font-size: 0.875rem; line-height: 1.5"></i>
    </button>
  </div>
</div>